import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import ArrowIcon from "../components/ArrowIcon";

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>

      <main>
        {/* 01 / Hero */}
        <section className="swiss-section !border-t-0 pt-7 lg:pt-9">
          <div className="swiss-grid">
            <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
              <span className="swiss-num">{t("kode.home.sectionLabel")}</span>
            </div>

            <div className="col-span-12 lg:col-span-10">
              <h1
                className="text-[clamp(2.75rem,6vw,6rem)] font-black tracking-tightest leading-[0.95] text-ink"
                style={{ maxWidth: "18ch" }}
              >
                {t("kode.home.h1Line1")}
                <br />
                {t("kode.home.h1Line2")}
                <br />
                {t("kode.home.h1Line3")}
              </h1>

              <p
                className="text-body-lg text-ink-70 mt-6"
                style={{ maxWidth: "60ch" }}
              >
                {t("kode.home.lead")}
              </p>

              {/* Two doors */}
              <div className="doors">
                <Link to="/wallets" className="door">
                  <span className="num">I</span>
                  <h3>{t("kode.home.doorWalletsH3")}</h3>
                  <p className="desc">{t("kode.home.doorWalletsDesc")}</p>
                  <span className="for">{t("kode.common.for")}</span>
                  <p className="audiences">{t("kode.home.doorWalletsAudiences")}</p>
                  <span className="enter">
                    {t("kode.home.doorWalletsEnter")}
                    <ArrowIcon />
                  </span>
                </Link>

                <Link to="/ai-data" className="door">
                  <span className="num">II</span>
                  <h3>{t("kode.home.doorAiH3")}</h3>
                  <p className="desc">{t("kode.home.doorAiDesc")}</p>
                  <span className="for">{t("kode.common.for")}</span>
                  <p className="audiences">{t("kode.home.doorAiAudiences")}</p>
                  <span className="enter">
                    {t("kode.home.doorAiEnter")}
                    <ArrowIcon />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default HomePage;
